import Marquee from "react-fast-marquee";
import { TRUSTED_ENTERPRISES } from "@/lib/data";

const TrustedBy = () => {
    return (
        <section data-testid="trusted-section" className="relative py-16 border-y border-white/[0.06] bg-[#0a041a] overflow-hidden">
            <div className="absolute inset-0 pointer-events-none">
                <div className="hero-orb w-[400px] h-[400px] bg-[#A100FF]/8 top-0 left-1/2 -translate-x-1/2" />
            </div>
            <div className="sxe-container relative">
                <div className="text-center mb-10">
                    <div className="overline">
                        <span className="dot" /> Trusted by enterprises worldwide
                    </div>
                    <p className="mt-4 text-[#B0A3C4] text-sm max-w-xl mx-auto">
                        Global enterprises across BFSI, tech, healthcare, and manufacturing build capability with SpringXE.
                    </p>
                </div>

                <Marquee gradient={true} gradientColor="#0a041a" gradientWidth={120} speed={35} pauseOnHover>
                    {TRUSTED_ENTERPRISES.map((e, i) => (
                        <div
                            key={e.name}
                            data-testid={`trusted-logo-${i}`}
                            className="mx-10 h-14 flex items-center opacity-70 hover:opacity-100 transition-opacity"
                            title={e.name}
                        >
                            {e.logo ? (
                                <img
                                    src={e.logo}
                                    alt={e.name}
                                    loading="lazy"
                                    className="h-8 md:h-9 w-auto object-contain"
                                    onError={(evt) => { evt.currentTarget.style.display = "none"; }}
                                />
                            ) : (
                                <span className="font-display font-semibold tracking-[-0.03em] text-white/85 text-xl md:text-2xl whitespace-nowrap">
                                    {e.name}
                                </span>
                            )}
                        </div>
                    ))}
                </Marquee>
            </div>
        </section>
    );
};

export default TrustedBy;
